import React from 'react';
import { CtaButton } from '../CtaButton';
import { painPoints } from '../../data/landing';
export function PainPoints() {
  return <section className="bg-navy-950 py-16 text-white sm:py-24" aria-labelledby="pain-title" data-id="element-214" data-mp="1twgy0yfp2mct">
      <div className="mx-auto max-w-5xl px-5" data-id="element-215" data-mp="27nvfh0tyefhr">
        <div className="text-center" data-id="element-216" data-mp="22vlr3p8hlnhl">
          <h2 id="pain-title" className="mx-auto max-w-3xl text-balance font-display text-[2rem] font-black leading-tight sm:text-5xl" data-id="element-217" data-mp="22uj1dkmwhr39">
            Do You Recognize Yourself in Any of These Situations?
          </h2>
          <p className="mt-4 text-lg text-white/75" data-id="element-218" data-mp="2ql6d6gzxt0v3">
            If you answer <strong className="text-ember-400" data-id="element-219" data-mp="2qkdg67qs5pq5">YES</strong> to any of them, this playbook was created for
            you.
          </p>
        </div>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2 sm:gap-4" data-id="element-220" data-mp="w6lwsginfrhi">
          {painPoints.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex gap-4 rounded-2xl bg-white/[0.06] p-5 ring-1 ring-white/10" data-id="element-221" data-mp="s6liqwzgpiaz">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-500/15" data-id="element-222" data-mp="1n94ou6666n2q">
                <Icon className="h-5 w-5 text-brand-400" aria-hidden="true" data-id="element-223" data-mp="1s7fx4cgtgpiu" />
              </span>
              <p className="text-base leading-relaxed text-white/90" data-id="element-224" data-mp="1x4et70k1j6jo">{text}</p>
            </li>)}
        </ul>

        <div className="mx-auto mt-14 max-w-2xl text-center" data-id="element-225" data-mp="21ysshe1tpxtm">
          <p className="font-display text-3xl font-black italic text-brand-400 sm:text-4xl" data-id="element-226" data-mp="26urcyqk16vor">
            And it doesn’t have to stay that way.
          </p>
          <p className="mt-6 text-lg leading-relaxed text-white/80" data-id="element-227" data-mp="2fwhame4iaquz">
            Because the problem isn’t necessarily a lack of knowledge.
          </p>
          <p className="mt-4 rounded-2xl bg-white p-5 text-lg font-bold leading-relaxed text-navy-900 sm:text-xl" data-id="element-228" data-mp="2kv229p5p027t">
            The problem is that having knowledge is not the same as having a system for organizing and applying it.
          </p>
          <p className="mt-6 text-lg leading-relaxed text-white/80" data-id="element-229" data-mp="igv16bfh5bpv">
            That’s exactly why I created the <strong className="text-white" data-id="element-230" data-mp="efjae2kv6kg3">Hernia Clinical Playbook™</strong>. I
            didn’t want to create another mountain of theory. I wanted to create a practical tool you could use to
            organize your assessment, structure your clinical reasoning, and plan your sessions.
          </p>
        </div>

        <CtaButton className="mt-12" tone="dark" label="I want a structured system" data-id="element-231" data-mp="11exnujkjuwki" />
      </div>
    </section>;
}